import { render, staticRenderFns } from "./MultiselectForm.vue?vue&type=template&id=73067812&scoped=true&"
import script from "./MultiselectForm.vue?vue&type=script&lang=js&"
export * from "./MultiselectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73067812",
  null
  
)

export default component.exports